import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {}

  classApplied = false;
  open = false;

  toggleClass() {
    this.classApplied = !this.classApplied;
  }

  get isSolutionsActive(): boolean {
    return this.router.url.startsWith('/products/solution1') ||
           this.router.url.startsWith('/products/solution2');
  }
}
